import { isFeatureEnabled } from '../../config/featureFlags';

const getAdminFilters = (userRole) => {
  const baseFilters = [
    {
      text: 'View and edit Users',
      value: 'viewUsers',
    },
    {
      text: 'Add a new User',
      value: 'newUser',
    },
    {
      text: 'Edit Company Demographics',
      value: 'companyDemo',
    },
    {
      text: 'Update Supplier Profile',
      value: 'myCapabilities',
    },
  ];

  // Add Remote Access option if feature is enabled
  if (isFeatureEnabled('ENABLE_REMOTE_ACCESS')) {
    baseFilters.push({
      text: 'Remote Access',
      value: 'remoteAccess',
    });
  }

  // Only show bid match settings for non-government users
  if (userRole !== 'GOVERNMENT_USER') {
    baseFilters.push({
      text: 'Update Bid Match Settings',
      value: 'bidMatch',
    });
  }

  // Add subscription option if feature is enabled
  if (isFeatureEnabled('ENABLE_BILLSBY')) {
    baseFilters.push({
      text: 'Update Subscription',
      value: 'updateSubscription',
    });
  }

  return baseFilters;
};

export default {
  header: 'Organization Admin',
  groupKey: 'admin',
  getFilters: getAdminFilters,
  // Keep the original filters for backward compatibility
  filters: [
    {
      text: 'View and edit Users',
      value: 'viewUsers',
    },
    {
      text: 'Add a new User',
      value: 'newUser',
    },
    {
      text: 'Edit Company Demographics',
      value: 'companyDemo',
    },
    {
      text: 'Update Supplier Profile',
      value: 'myCapabilities',
    },
    ...(isFeatureEnabled('ENABLE_REMOTE_ACCESS') ? [{
      text: 'Remote Access',
      value: 'remoteAccess',
    }] : []),
    {
      text: 'Update Bid Match Settings',
      value: 'bidMatch',
    },
    ...(isFeatureEnabled('ENABLE_BILLSBY') ? [{
      text: 'Update Subscription',
      value: 'updateSubscription',
    }] : []),
  ],
};



// WEBPACK FOOTER //
// ./src/config/searchFilters/AdminFilters.js